export default __webpack_public_path__ + "static/media/Ballroll_00076.58f62bcf.png";